export default "__VITE_ASSET__fa556db2__"